enum TraceTypeEnum {
  STATUS = 'status',
  RESULT = 'result',
  ERROR = 'error',
}

export { TraceTypeEnum };
